import React from 'react';

const LoadingSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Overall Status Skeleton */}
      <div className="bg-gray-200 rounded-lg h-24"></div>

      {/* Critical Issues Skeleton */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <div className="h-5 w-5 bg-gray-200 rounded mr-2"></div>
          <div className="h-5 w-32 bg-gray-200 rounded"></div>
        </div>
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        </div>
      </div>

      {/* Warnings Skeleton */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <div className="h-5 w-5 bg-gray-200 rounded mr-2"></div>
          <div className="h-5 w-24 bg-gray-200 rounded"></div>
        </div>
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded w-4/5"></div>
          <div className="h-4 bg-gray-200 rounded w-3/5"></div>
        </div>
      </div>

      {/* Detailed Validations Skeleton */}
      <div className="space-y-4">
        <div className="h-6 w-48 bg-gray-200 rounded"></div>
        
        {/* Three validation sections */}
        {[1, 2, 3].map((section) => (
          <div key={section} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
              <div className="h-4 w-32 bg-gray-200 rounded"></div>
            </div>
            <div className="p-4 space-y-3">
              {[1, 2, 3].map((item) => (
                <div key={item} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
                  </div>
                  <div className="flex-1 min-w-0 space-y-2">
                    <div className="h-4 w-24 bg-gray-200 rounded"></div>
                    <div className="h-3 w-full bg-gray-200 rounded"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Recommendations Skeleton */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <div className="h-5 w-5 bg-gray-200 rounded mr-2"></div>
          <div className="h-5 w-36 bg-gray-200 rounded"></div>
        </div>
        <div className="space-y-3">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="flex items-start">
              <div className="h-4 w-4 bg-gray-200 rounded mr-2 mt-0.5 flex-shrink-0"></div>
              <div className="h-4 bg-gray-200 rounded flex-1"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Animated Loading Text */}
      <div className="text-center py-8">
        <div className="flex items-center justify-center space-x-2">
          <svg className="animate-spin h-5 w-5 text-gov-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span className="text-gov-blue font-medium">Analyzing PVQ submission...</span>
        </div>
        <p className="text-gray-500 text-sm mt-2">
          Running validation checks against common FSO rejection patterns
        </p>
      </div>
    </div>
  );
};

export default LoadingSkeleton;